// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"552581":"lazy-survey","706569":"lazy-jury"}[chunkId] + "." + {"552581":"3f0a882f","706569":"4a8c4466"}[chunkId] + ".chunk.css";
};